// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__waWCI","label":"Radio_label__1NSO5","checkMark":"Radio_checkMark__39ibt","disabled":"Radio_disabled__GJNdM"};